export var WhoResponsibleForAlcohol;
(function (WhoResponsibleForAlcohol) {
    WhoResponsibleForAlcohol["VenueOrCaterer"] = "venue_or_caterer";
    WhoResponsibleForAlcohol["Insured"] = "insured";
})(WhoResponsibleForAlcohol || (WhoResponsibleForAlcohol = {}));
export var WillThereBeChargeForAlcohol;
(function (WillThereBeChargeForAlcohol) {
    WillThereBeChargeForAlcohol["Included"] = "included_in_admission";
    WillThereBeChargeForAlcohol["NoCharge"] = "no_charge";
    WillThereBeChargeForAlcohol["SoldByGlass"] = "sold_by_glass";
})(WillThereBeChargeForAlcohol || (WillThereBeChargeForAlcohol = {}));
const formatWillThereBeChargeForAlcohol = (opt) => {
    switch (opt) {
        case WillThereBeChargeForAlcohol.Included:
            return 'Alcohol is included with the purchase of admission';
        case WillThereBeChargeForAlcohol.NoCharge:
            return 'There will be no charge for alcohol or admission';
        case WillThereBeChargeForAlcohol.SoldByGlass:
            return 'Alcohol will be sold by the glass';
    }
};
const formatWhoResponsibleForAlcohol = (opt) => {
    switch (opt) {
        case WhoResponsibleForAlcohol.VenueOrCaterer:
            return 'Venue or Caterer';
        case WhoResponsibleForAlcohol.Insured:
            return 'Insured';
    }
};
export const WhoResponsibleForAlcoholOptions = Object.values(WhoResponsibleForAlcohol).map((value) => {
    return {
        value,
        name: formatWhoResponsibleForAlcohol(value),
    };
});
export const WillThereBeChargeForAlcoholOptions = Object.values(WillThereBeChargeForAlcohol).map((value) => {
    return {
        value,
        name: formatWillThereBeChargeForAlcohol(value),
    };
});
